import { AuthType } from './types';

const STORAGE_KEY = 'sessionExpired';

// Only the local sign-in page renders a form the notice can appear on. The other
// strategies hand straight off to an identity provider, so a flag written there would
// never be read and would sit in the tab until it closed.
const STRATEGIES_WITH_A_SIGN_IN_FORM = new Set<AuthType>(['local']);

const signInPageCanShowNotice = (): boolean =>
  STRATEGIES_WITH_A_SIGN_IN_FORM.has(import.meta.env.VITE_API_AUTH_STRATEGY);

export const markSessionExpired = (): void => {
  if (!signInPageCanShowNotice()) {
    return;
  }
  sessionStorage.setItem(STORAGE_KEY, 'true');
};

export const consumeSessionExpiredNotice = (): boolean => {
  const wasExpired = sessionStorage.getItem(STORAGE_KEY) === 'true';
  sessionStorage.removeItem(STORAGE_KEY);
  return wasExpired;
};
